const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/videos`;

export const addVideo = async (clerkId, videoDetails) => {
  try {
    const requestBody = {
      clerkId,
      ...videoDetails,
    };
    const response = await fetch(`${BASE_URL}/add/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    if (response.status === 201) {
      return { updated: true };
    } else {
      return { updated: false };
    }
  } catch (error) {
    console.error("error ", error);
    return { updated: false };
  }
};

export const getDashboardVideos = async () => {
  try {
    const response = await fetch(`${BASE_URL}/dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Error: Failed to fetch videos, status: ", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error fetching videos: ", error);
    throw error;
  }
};

export const getVideosByCategory = async (category) => {
  try {
    const response = await fetch(`${BASE_URL}/category?category=${category}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Error: Failed to fetch videos, status:", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error fetching videos: ", error);
    throw error;
  }
};

export const getLatestVideos = async () => {
  try {
    const response = await fetch(`${BASE_URL}/latest`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Error: Failed to fetch videos, status: ", response.status);
      return null;
    }
  } catch (error) {
    console.error("Error fetching videos: ", error);
    throw error;
  }
};
